"use client";

import type { HelpCenterAction } from "@/lib/support/help-center-data";
import { sendHelpCenterBridgeRequest } from "@/lib/support/native-bridge";
import { useState } from "react";

type BridgeActionButtonProps = {
  action: HelpCenterAction;
  payload?: Record<string, unknown>;
  fallbackHref: string;
  children: string;
  className?: string;
};

export function BridgeActionButton({
  action,
  payload,
  fallbackHref,
  children,
  className,
}: BridgeActionButtonProps) {
  const [isSending, setIsSending] = useState(false);

  const handleAction = async () => {
    if (isSending) {
      return;
    }

    setIsSending(true);
    try {
      const response = await sendHelpCenterBridgeRequest(action, payload);
      if (response.status !== "ok") {
        window.location.href = fallbackHref;
      }
    } catch {
      window.location.href = fallbackHref;
    } finally {
      setIsSending(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleAction}
      className={className}
      disabled={isSending}
      data-support-bridge-action={action}
    >
      {isSending ? "Opening..." : children}
    </button>
  );
}
